//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import iconFb from "../../../images/icons/icon_fb.svg";
import iconTwitter from "../../../images/icons/icon_twitter.svg";
import iconEmail from "../../../images/icons/icon_email.svg";
import iconChecklistWhite from "../../../images/icons/icon_check_white.svg";

class ModalShare extends PolymerElement {
  static get template() {
    return html`
      <style>
        button {
          font-family: "Lato", sans-serif;
        }
        .show {
          display: block;
        }
        .hide {
          display: none;
        }
        .modal {
          position: fixed;
          z-index: 1;
          padding-top: 100px;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          overflow: auto;
          background-color: rgb(0, 0, 0);
          background-color: rgba(0, 0, 0, 0.4);
        }

        /* Modal Content */
        .modal-content {
          width: 420px;
          border-radius: 5px;
          background-color: #fefefe;
          padding: 24px;
          position: relative;
          z-index: 100;
          margin: 15% auto;
          /* 15% from the top and centered */
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
        }

        .close {
          color: #aaaaaa;
          font-size: 28px;
          font-weight: bold;
        }

        .close:hover,
        .close:focus {
          color: #000;
          text-decoration: none;
          cursor: pointer;
        }
        h2 {
          margin: 0;
        }
        .header {
          display: flex !important;
          align-items: center;
          justify-content: space-between;
        }
        .content-link {
          display: flex;
          background-color: #e5efff !important;
          padding: 12px;
          color: #424242;
          justify-content: space-between;
          align-items: center;
        }
        .content-link span {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .content-link button {
          margin-left: 40px;
          border: 0;
          color: #3570d2;
          font-size: 16px;
          cursor: pointer;
        }
        hr {
          border: 1px solid #bcbcbc;
          margin-top: 24px;
          margin-bottom: 18px;
        }
        .text-share {
          color: #7f7f7f;
          font-size: 18px;
          font-weight: bold;
        }
        .btn-share {
          border: none;
          background-color: white;
          cursor: pointer;
          margin-top: 24px;
          text-decoration: none;
        }
        .content-toast {
          width:260px;
          padding: 16px;
          position: absolute;
          height: 56px;
          border: 1px solid #007C41;
          box-sizing: border-box;
          border-radius: 8px;
          background-color: #007C41;
          top: 22%;
          left: 0; 
          right: 0; 
          margin-left: auto; 
          margin-right: auto; 
          align-items: center;
          text-align: center;
        }
        .content-toast span {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #FFFFFF;
        }
        .content-toast img {
          width: 15px;
          height: 15px;
          margin-right: 10px;
        }
      </style>
      <div id="myModal" class$="modal [[handleModal(isActive)]]">
        <div class$="content-toast [[handleModal(isToastActive)]]">
          <img src="[[iconChecklistWhite]]" />
          <span>Tautan Berhasil Disalin !</span>
        </div>
        <div class="modal-content">
          <div class="header">
            <h2>Bagikan Webinar</h2>
            <span class="close" on-click="handleCloseModal">&times;</span>
          </div>
          <div class="content-link">
            <span>[[url]]</span>
            <button on-click="onCopy">Copy</button>
          </div>
          <hr />
          <h2 class="text-share">Bagikan ke Media Sosial</h2>
          <a
            href="https://www.facebook.com/sharer/sharer.php?u=[[url]]&t=[[webinarTitle]]"
            onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
            target="_blank"
            title="Share on Facebook"
            class="btn-share"
          >
            <img src="[[iconFb]]" />
          </a>
          <a
            href="https://twitter.com/share?url=[[url]]&via=[[webinarTitle]]"&text=Check out this site [[url]]"
            onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
            target="_blank"
            title="Share on Twitter"
            class="btn-share"
          >
            <img src="[[iconTwitter]]" />
          </a>
          <a
            href="mailto:?subject=[[webinarTitle]];body=Check out this site [[url]]"
            title="Share on Email"
            class="btn-share"
          >
            <img src="[[iconEmail]]" />
          </a>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      iconFb: {
        type: String,
        value: iconFb,
      },
      iconTwitter: {
        type: String,
        value: iconTwitter,
      },
      iconEmail: {
        type: String,
        value: iconEmail,
      },
      iconChecklistWhite: {
        type: String,
        value: iconChecklistWhite,
      },
      isActive: {
        type: Boolean,
        notify: true,
      },
      isToastActive: {
        type: Boolean,
        value: false,
        notify: true,
      },
      webinarId: {
        type: String,
      },
      webinarTitle: {
        type: String,
      },
      url: {
        type: String,
        value: "",
      },
      webinarType: {
        type: String,
      },
    };
  }

  ready() {
    super.ready();
    if (this.webinarId) {
      this.url = `${window.location.origin}/webinar/${this.webinarId}?type=${this.webinarType}`;
    }
  }

  handleCloseModal() {
    this.isActive = false;
  }

  handleModal(isActive) {
    return isActive ? "show" : "hide";
  }

  onCopy() {
    navigator.clipboard.writeText(this.url);
    this.isToastActive = true;
    setTimeout(() => {
      this.isToastActive = false;
    }, 2000);
  }
}
customElements.define("modal-share", ModalShare);
